<template>
    <div class="side-title">
        <router-link to="/" exact>
            <span class="notify"></span>
            <map-icon></map-icon>
            <span class="title">map</span>
        </router-link>
        <router-link to="/tools">
            <span class="notify"></span>
            <codepen-icon></codepen-icon>
            <span class="title">tools</span>
        </router-link>
        <router-link to="/errors">
            <span class="notify"></span>
            <alert-triangle-icon></alert-triangle-icon>
            <span class="title">errors</span>
        </router-link>
        <router-link to="/monitoring">
            <span class="notify"></span>
            <activity-icon></activity-icon>
            <span class="title">monitoring</span>
        </router-link>
        <router-link to="/access-logs">
            <span class="notify"></span>
            <eye-icon></eye-icon>
            <span class="title">logs</span>
        </router-link>
        <div class="accessories">
            <p v-on:click="notepadVisible = !notepadVisible" v-bind:class="{'accessory-animated':accessoryAnimated}" v-on:animationend="animationEnded" class="place">
                <file-text-icon v-if="!notepadVisible"></file-text-icon>
                <x-icon v-else class="svg-close-button"></x-icon>
            </p>
        </div>
        <div id="notepad" v-show="notepadVisible" v-on:click.self="notepadVisible = false">
            <div id="notepad-frame">
                <textarea v-model="text"></textarea>
                <p class="utils">
                    <span>{{this.$selectedURLS.length}} lines / {{text.length}} characters</span>
                    <button class="red" v-on:click="removeAll"><delete-icon></delete-icon></button>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Socket from '@/IOSocket'
    import CustomEvents from '@/CustomEvents'
    import Storages from 'js-storage'

    import { MapIcon, ZapIcon, AlertTriangleIcon, ActivityIcon, EyeIcon, CodepenIcon, FileTextIcon, DeleteIcon, XIcon } from 'vue-feather-icons'

    export default {
        components:{
            MapIcon,
            ZapIcon,
            AlertTriangleIcon,
            ActivityIcon,
            EyeIcon,
            CodepenIcon,
            FileTextIcon,
            CustomEvents,
            Storages,
            DeleteIcon,
            XIcon
        },
        name: "Menu",
        data: function (){
            return {
                notepadVisible: false,
                accessoryAnimated: false,
                text: ''
            }
        },
        watch: {
            text: function () {
                this.$selectedURLS = this.text.split('\n');
                Storages.localStorage.set('APP:SelectedURLs', this.$selectedURLS);
            }
        },
        methods:{
            noteAdded: function (msg) {
                this.accessoryAnimated = true;
                if (typeof msg === 'string') {
                    this.$selectedURLS.push(msg);
                }else{
                    this.$selectedURLS = this.$selectedURLS.concat(msg);
                }

                this.$selectedURLS = this.$selectedURLS.filter(item => {
                    return item.trim() !== ''
                })

                this.text = this.$selectedURLS.join('\n');
            },
            noteRemoved: function (msg){
                this.accessoryAnimated = true;
                if (typeof msg === 'string') {
                    this.$selectedURLS.splice(this.$selectedURLS.indexOf(msg), 1);
                }else{
                    msg.forEach( item => {
                        this.$selectedURLS.splice(this.$selectedURLS.indexOf(item), 1);
                    });
                }

                this.$selectedURLS = this.$selectedURLS.filter(item => {
                    return item.trim() !== ''
                })

                this.text = this.$selectedURLS.join('\n');
            },
            removeAll: function (){
                this.$selectedURLS.length = 0;
                this.text = this.$selectedURLS.join('\n');
            },
            animationEnded: function (){
                this.accessoryAnimated = false;
            },
            wsReceived:function (msg) {
            }
        },
        created: function () {
            CustomEvents.$on("add-note", this.noteAdded);
            CustomEvents.$on("remove-note", this.noteRemoved);
            Socket.$on("message", this.wsReceived);
            this.text = this.$selectedURLS.join('\n');
        },
        beforeDestroy(){
            CustomEvents.$off("add-note", this.noteAdded);
            CustomEvents.$off("remove-note", this.noteRemoved);
            Socket.$off("message", this.wsReceived);
        }
    }
</script>

<style scoped>
    #notepad{
        position: absolute;
        background-color: rgba(0,0,0,0.5);
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        z-index: 100000;
    }

    .svg-close-button{
        background-color: #ffffff;
        color: #425360;
        position: relative;
        z-index: 100100;
        border-radius: 50%;
        box-shadow: 0px 0px 20px #000000;
        transform: rotateY(360deg);
        transition: all 0.5s;
    }

    #notepad-frame{
        position: absolute;
        top: 20%;
        left: 20%;
        width: calc(60% - 6rem);
        height: calc(60% - 6rem);
        background-color: #CCCCCC;
        border-bottom: 2px solid #656565;
        border-top: 2px solid #eeeeee;
        border-right: 2px solid #eeeeee;
        border-left: 2px solid #656565;
        padding: 3rem;
        display: flex;
        flex-wrap: wrap;
    }

    #notepad textarea{
        width: 100%;
        height: calc(100% - 1rem);
        padding: 0.2rem;
        border-top: 2px solid #656565;
        border-bottom: 2px solid #eeeeee;
        border-left: 2px solid #eeeeee;
        border-right: 2px solid #656565;
        background-color: #ffffff;
        outline: none;
        box-shadow: inset -1px 1px 0px 1px rgba(0,0,0,0.5);
    }

    #notepad .utils{
        margin: 0.5rem 0;
        flex: 1;
        text-align: end;
    }

    #notepad span{
        margin: 0.5rem;
        display: inline-block;
    }

    @keyframes move {
        0% {
            transform: scale(1);
        }

        50% {
            transform: scale(1.5);
        }
    }

    @keyframes accessory-bounce {
        0% {
            position: relative
        }

        50% {
            color: #8a2be2;
            transform: scale(1.5);
            filter: drop-shadow(1px 1px 1px #5a5a5a)
        }

        to {
            transform: scale(1);
            filter: drop-shadow(0 0 0 #5a5a5a)
        }
    }

    .side-title {
        border-top: 2px solid #ff223c;
        border-right: 2px solid #ED213A;
        background: #ED213A;  /* fallback for old browsers */
        background: -webkit-linear-gradient(to bottom, #93291E, #ED213A);  /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to bottom, #93291E, #ED213A); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        color: #FFF;
        border-bottom: 2px solid #4e1b14;
        border-left: 2px solid #4e1b14;
        text-shadow:-1px 1px 0px #4e1b14;
        width: auto;
        min-height: fit-content;
    }

    .accessories,.side-title a {
        display: flex;
        align-items: center
    }

    .side-title a {
        margin: -0.6rem 0.5rem 0.2rem 0.5rem;
        flex-direction: column;
        align-content: center;
        justify-items: center;
        color: #fff;
    }


    .side-title span.notify {
        display: inline;
        position: relative;
        width: .5rem;
        height: .5rem;
        margin: .25rem;
        background-color: #ff3139;
        border-radius: 50%;
        visibility: hidden;
        top: 0.75rem;
        left: 0.75rem;
        filter: drop-shadow(-0.1rem 0.1rem 0.1rem #333);
        z-index: 100;
        animation: move ease-in-out 0.3s infinite;
    }

    .router-link-active span {
        display: revert
    }

    .side-title a svg {
        filter: drop-shadow(0 0 0 #333)
    }

    .router-link-active a span.title,.side-title a span.title {
        filter: none;
        width: unset;
        margin: 0;
        font-weight: 400;
        background-color: unset;
        border-radius: 0;
        font-size: 1rem;
        font-family: monospace;
        display: inline-block;
        text-align: center;
        vertical-align: middle;
        height: 1rem
    }

    .side-title .router-link-active,.side-title a:hover {
        text-decoration: none;
        text-shadow: none
    }

    .side-title .router-link-active svg,.side-title a:hover svg {
        color: #ff7a2c;
        filter: drop-shadow(0 0 0.1rem #333);
        transition: 0.3s;
    }

    .page-title a.alert svg,.side-title a.alert {
        color: #ff6107;
        -webkit-filter: drop-shadow(1px 1px 1px rgba(0,0,0,.7));
        filter: drop-shadow(1px 1px 1px rgba(0,0,0,.7));
        margin: .3rem
    }

    .accessories {
        flex: 1 100%;
        height: 100%;
        margin: 0;
        justify-content: flex-end
    }

    .side-title button:disabled {
        opacity: .5
    }

    .side-title button {
        margin: 0
    }

    .side-title div {
    }

    .accessory-animated {
        animation: accessory-bounce 300ms ease 300ms 1
    }
</style>
